import React, { useState } from 'react'

import Chart from 'react-apexcharts'

import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'

import AuthService from '../../business-api/AuthService'

import {
    STYLE,
} from '../../business-const/Style/Style'

import {
    mes,
} from '../Date/Date'

import {
    nvl,
    formataValor,
    formataNumero,
    formataPerc,
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosValor,
    formataTableCellBodyExibeDadosTitulo,
    formataTableCellBodyExibeDadosValor,
    formataTableCellBodyExibeDadosPerc,
    formataTableCellBodyExibeDadosTotalTitulo,
    formataTableCellBodyExibeDadosTotalValor,
} from '../Formata/Formata'

import {
    round
} from '../round/round'

import {
    sortDesc
} from '../../business-components/Sort/Sort'

import {
    GridContainer,
    GridItem6,
    GridItem12,
} from '../Grid/Grid'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../Table/TableExibeDados'

import {
    CustomizedDialogsPopup
} from '../Dialog/CustomizeDialogs'


const calculaValorMensal = (valueCalc, opts, dataSimulacaoEstudo, dataPointIndexZoom) => {

    return opts.dataPointIndex === 0 || dataPointIndexZoom === 0
        ?
            round(valueCalc / (12 - mes(dataSimulacaoEstudo) + 1), 2)
        :
            round(valueCalc / 12, 2)
}

const calculaValorMensalChart = (value, opts, dataSimulacaoEstudo, series, dataPointIndexZoom) => {

    const valueCalc =
        opts && (opts.seriesIndex === 0 || opts.seriesIndex) && series && series[opts.seriesIndex].media
            ? 
                series[opts.seriesIndex].media[opts.dataPointIndex]
            :
                value
                
    return opts
        ?
            ' (' + formataValor(calculaValorMensal(valueCalc, opts, dataSimulacaoEstudo, dataPointIndexZoom), 2) + ')'
        :
            ''
}


export const ChartPadrao = props => {

    const [zoom, setZoom] = useState(false)

    return (
        <GridContainer>
            <GridItem12>
                <div
                    align='left'
                    className={props.report ? 'mt--5' : ''}
                    style={{
                        height: props.height ? props.height + (props.report ? 0 : 15) : 350 + (props.report ? 0 : 65),
                    }}
                >
                    <Chart
                        type={props.type ? props.type : 'area'}
                        series={props.series}
                        height={props.height ? props.height : props.report ? 300 : 400}
                        options={{
                            annotations: props.annotations ? props.annotations: {},
                            chart: {
                                height: 350,
                                fontFamily: AuthService.obterFontFamily(false), // mudança da fonte
                                type: props.type,
                                stacked: props.stacked,
                                sparkline: {
                                    enabled: props.barHorizontal ? true : false
                                },
                                dropShadow: {
                                    enabled: false,
                                    color: '#000',
                                    top: 18,
                                    left: 7,
                                    blur: 10,
                                    opacity: 0.2,
                                },
                                events: {
                                    dataPointSelection: function (e, chart, opts) {

                                        if (props.eventsDataPointSelection) {

                                            props.eventsDataPointSelection(
                                                {
                                                    seriesIndex: opts.seriesIndex,
                                                    dataPointIndex: opts.dataPointIndex,
                                                    ind: props.eventsDataPointSelectionInd,
                                                }
                                            )
                                        }

                                        if (props.zoom) {

                                            const serieZoomAux = []
                                            const mediaZoomAux = []
                                            const categoriesZoomAux = []
                                            const paletaCoresZoomAux = []
                                            let ordemZoomAux = []
                                            let indOrdemZoomAux = -1

                                            let totalSerieZoomAux = 0
                                            let totalMediaZoomAux = 0

                                            props.series?.forEach( (linhaSeries, index) => {

                                                if (linhaSeries.data[opts.dataPointIndex] !== null) {

                                                    indOrdemZoomAux++

                                                    serieZoomAux.push(
                                                        linhaSeries.data[opts.dataPointIndex]
                                                    )

                                                    totalSerieZoomAux += linhaSeries.data[opts.dataPointIndex]

                                                    if (linhaSeries.media) {

                                                        const valorMediaZoomAux =
                                                            opts.dataPointIndex === 0
                                                                ?
                                                                    round(linhaSeries.media[opts.dataPointIndex] /
                                                                        (12 - mes(props.dataSimulacaoEstudo) + 1), 2)
                                                                :
                                                                    round(linhaSeries.media[opts.dataPointIndex] / 12, 2)

                                                        mediaZoomAux.push(
                                                            valorMediaZoomAux,
                                                        )

                                                        totalMediaZoomAux += valorMediaZoomAux

                                                        ordemZoomAux.push(
                                                            {
                                                                ind: indOrdemZoomAux,
                                                                ordem: valorMediaZoomAux
                                                            }
                                                        )
                                                    } else {

                                                        ordemZoomAux.push(
                                                            {
                                                                ind: indOrdemZoomAux,
                                                                ordem: linhaSeries.data[opts.dataPointIndex]
                                                            }
                                                        )
                                                    }

                                                    categoriesZoomAux.push(
                                                        linhaSeries.name
                                                    )

                                                    paletaCoresZoomAux.push(
                                                        props.paletaCores[index]
                                                    )
                                                }
                                            })

                                            ordemZoomAux = sortDesc(ordemZoomAux)

                                            const zoomAux =
                                                {
                                                    seriesZoom: [],
                                                    labelSeriesZoom: mediaZoomAux.length > 0 ? LABEL.media : LABEL.valor,
                                                    totalSeriesZoom: mediaZoomAux.length > 0 ? totalMediaZoomAux : totalSerieZoomAux,
                                                    categoriesZoom: [],
                                                    paletaCoresZoom: [],
                                                    dataPointIndexZoom: opts.dataPointIndex,
                                                }

                                            ordemZoomAux?.forEach( (item, ind) => {

                                                zoomAux.seriesZoom.push(
                                                    mediaZoomAux.length > 0
                                                        ?
                                                            mediaZoomAux[item.ind]
                                                        :
                                                            serieZoomAux[item.ind]
                                                )

                                                zoomAux.categoriesZoom.push(
                                                    categoriesZoomAux[item.ind]
                                                )

                                                zoomAux.paletaCoresZoom.push(
                                                    paletaCoresZoomAux[item.ind]
                                                )
                                            })

                                            setZoom(zoomAux)
                                        }
                                    }
                                },
                                toolbar: {
                                    show: (props.report && props.formatoReport === HARDCODE.idFormatoReportImpressao) || props.aiFT || props.notShowToolbar ? false : true,
                                },
                                animations: {
                                    enabled: props.report ? false : false/*true*/,
                                    speed: 600,
                                }
                            },
                            plotOptions: {
                                bar: {
                                    horizontal: props.barHorizontal,
                                    columnWidth: props.columnWidth ? props.columnWidth : '70%',
                                    borderRadius: 10,
                                    distributed: props.distributed,
                                    dataLabels: {
                                        position: 'center',
                                        hideOverflowingLabels: false,
                                    },
                                }
                            },
                            colors: props.paletaCores,
                            dataLabels: {
                                enabled: props.report ? props.dataLabelsEnabledReport : props.dataLabelsEnabled,
                                textAnchor: props.barHorizontal ? 'start' : 'middle',
                                dropShadow: {
                                    enabled: true
                                },
                                style: {
                                    //colors: props.barHorizontal ? ['#f2f2f2'] : props.paletaCores,
                                    ...(props.dataLabelsType === "Especial"
                                            ?
                                                props.report
                                                    ? 
                                                        STYLE(false, false).styleChartPadraoDataLabelsEspecialReport
                                                    :
                                                        STYLE(false, false).styleChartPadraoDataLabelsEspecial
                                            :
                                                props.dataLabelsType === "Idade" || props.dataLabelsType === "IdadeIndex"
                                                    ?
                                                        props.report
                                                            ?
                                                                props.dataLabelsInterval === -1
                                                                    ?
                                                                        STYLE(false, false).styleChartPadraoDataLabelsIdadeMaiorReport
                                                                    :
                                                                        STYLE(false, false).styleChartPadraoDataLabelsIdadeReport
                                                            :
                                                                props.dataLabelsInterval === -1
                                                                    ?
                                                                        STYLE(false, false).styleChartPadraoDataLabelsIdadeMaior
                                                                    :
                                                                        STYLE(false, false).styleChartPadraoDataLabelsIdade
                                                    :
                                                        props.dataLabelsType === "Large"
                                                            ?
                                                                props.report
                                                                    ?
                                                                        STYLE(false, false).styleChartPadraoDataLabelsLargeReport
                                                                    :
                                                                        STYLE(false, false).styleChartPadraoDataLabelsLarge
                                                            :
                                                                props.dataLabelsType === "Medium"
                                                                    ?
                                                                        props.report
                                                                            ?
                                                                                STYLE(false, false).styleChartPadraoDataLabelsMediumReport
                                                                            :
                                                                                STYLE(false, false).styleChartPadraoDataLabelsMedium
                                                                    :
                                                                        props.report
                                                                            ?
                                                                                STYLE(false, false).styleChartPadraoDataLabelsReport
                                                                            :
                                                                                STYLE(false, false).styleChartPadraoDataLabels
                                        )
                                },
                                formatter: function (value, opts) {
                                    let valorFormatado = ''

                                    if (props.dataLabelsType === "Especial") {
                                        //let dataPointIndex4 = opts.dataPointIndex % 4
                                        //let dataPointIndexAnt12 = (opts.dataPointIndex + 2) % 12
                                        //let dataPointIndex12 = opts.dataPointIndex % 12
                                        //let seriesIndex2 = opts.seriesIndex % 2

                                        //if (
                                        //        value && 
                                        //        (
                                        //            (
                                        //                seriesIndex2 === 0 &&
                                        //                (
                                        //                    (
                                        //                        dataPointIndex4 === 0 && 
                                        //                        dataPointIndex12 !== 0
                                        //                    ) ||
                                        //                    (
                                        //                        dataPointIndexAnt12 === 0
                                        //                    ) ||
                                        //                    (
                                        //                        opts.dataPointIndex === 0
                                        //                    )
                                        //                )
                                        //            ) ||
                                        //            (
                                        //                seriesIndex2 === 1 && 
                                        //                dataPointIndex4 === 0
                                        //            )
                                        //        )
                                        //) {
                                            valorFormatado =
                                                value
                                                    ?
                                                        value >= 1000000
                                                        ?
                                                            formataValor(round(value / 1000000, 1), 1, true) + " M"
                                                        :
                                                            formataValor(round(value / 1000, 0), 0, true) + " K"
                                                    : 
                                                        ''
                                        //}
                                    } else {

                                        if (props.dataLabelsType === "Idade" || props.dataLabelsType === "IdadeIndex") {

                                            if (
                                                    value &&
                                                    opts &&
                                                    (opts.dataPointIndex || opts.dataPointIndex === 0) &&
                                                    (
                                                        opts.dataPointIndex === 0 ||
                                                        (
                                                            (   
                                                                props.dataLabelsType === "Idade" &&
                                                                props.dataLabelsInterval !== -1 &&
                                                                props.categories[opts.dataPointIndex] %
                                                                    (props.dataLabelsInterval ? props.dataLabelsInterval : 10) === 0
                                                            ) ||
                                                            (
                                                                props.dataLabelsType === "IdadeIndex" &&
                                                                props.dataLabelsInterval !== -1 &&
                                                                opts.dataPointIndex %
                                                                    (props.dataLabelsInterval ? props.dataLabelsInterval : 10) === 0
                                                            )
                                                        ) ||
                                                        (
                                                            props.dataLabelsDestaque &&
                                                            props.dataLabelsDestaque[
                                                                props.dataLabelsDestaque.length === 1 ? 0 : opts.seriesIndex] ===
                                                                    props.categories[opts.dataPointIndex]
                                                        ) ||
                                                        props.categories.length - 1 === opts.dataPointIndex
                                                    )
                                            ) {
                                            
                                                //if (props.mediaMensal) {

                                                    //valorFormatado =
                                                    //    formataValor(round(
                                                    //        calculaValorMensal(value, opts, props.dataSimulacaoEstudo,
                                                    //            opts.dataPointIndex) / 1000, 1), 1, true) + " K"

                                                //} else {

                                                    valorFormatado =
                                                        value >= 1000000
                                                        ?
                                                            formataValor(round(value / 1000000, 1), 1, true) + " M"
                                                        :
                                                            formataValor(round(value / 1000, 0), 0, true) + " K"

                                                    if (props.mediaMensal) {

                                                        valorFormatado +=
                                                            ' (' + formataValor(round(
                                                                calculaValorMensal(value, opts, props.dataSimulacaoEstudo,
                                                                    opts.dataPointIndex) / 1000, 1), 1, true) + ' K)'
                                                    }
                                                //}
                                            }

                                        } else {

                                            valorFormatado = props.valorNumero === "N"
                                                ?
                                                    (props.barHorizontal ? props.categories[opts.dataPointIndex] + ': ' : '') +
                                                        formataNumero(value)
                                                :
                                                    formataValor(value, 2)
                                        }
                                    }

                                    return valorFormatado
                                }
                            },
                            stroke: {
                                curve: props.curve ? props.curve : 'straight'/*'smooth'*/,
                                width:
                                    props.barHorizontal ? 0 : props.strokeWidth || props.strokeWidth === 0 ? props.strokeWidth : 2.3,
                            },
                            fill:
                                props.fillType === 'gradient'
                                    ?
                                        {
                                            type: 'gradient',
                                            gradient: {
                                                shade: 'light',
                                                type: "diagonal2",
                                                shadeIntensity: 0.5,
                                                //gradientToColors: undefined,
                                                inverseColors: true,
                                                opacityFrom: 0.8,
                                                opacityTo: 0.9,
                                                //stops: [0, 50, 100],
                                                // colorStops: []
                                            },
                                            //pattern: {
                                            //  style: 'verticalLines',
                                            //  width: 6,
                                            //  height: 6,
                                            //  strokeWidth: 2,
                                            //},
                                        }
                                    :
                                        props.fillType === 'unfilled'
                                            ?
                                                {
                                                    type: 'solid',
                                                    opacity: 0,
                                                }
                                            :
                                                {
                                                    type: 'solid',
                                                    opacity: props.fillOpacity ? props.fillOpacity : 1,
                                                },
                            title: {
                                text: props.report || props.sempreExibirTitleText ? props.titleText : '',
                                align: 'left',
                                style: {
                                    fontSize: '17px',
                                    fontWeight: 'bold',
                                }
                            },
                            grid: {
                                show: false,
                                // borderColor: "#fff",
                                // row: {
                                //   colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                                //   opacity: 0.5,
                                // },
                            },
                            markers: {
                                size: props.markersSize ? props.markersSize : 0,
                                //hover: { // performance
                                //    size: 6,
                                //},
                            },
                            xaxis: {
                                categories: props.categories,
                                title: {
                                    text: '',
                                },
                                axisBorder: {
                                    show: false,
                                },
                                labels: {
                                    show: props.barHorizontal ? false : true,
                                    //hideOverlappingLabels: false,
                                    rotate: props.xaxisRotate ? props.xaxisRotate : -45,
                                    rotateAlways: props.xaxisRotateAlways,
                                    style:
                                        props.xaxisType === "Large"
                                            ?
                                                props.report
                                                    ?
                                                        STYLE(false, false).styleChartPadraoXaxisLargeReport
                                                    :
                                                        STYLE(false, false).styleChartPadraoXaxisLarge
                                            :
                                                props.xaxisType === "Medium"
                                                    ?
                                                        props.report
                                                            ?
                                                                STYLE(false, false).styleChartPadraoXaxisMediumReport
                                                            :
                                                                STYLE(false, false).styleChartPadraoXaxisMedium
                                                    :
                                                        props.report
                                                            ?
                                                                STYLE(false, false).styleChartPadraoXaxisReport
                                                            :
                                                                STYLE(false, false).styleChartPadraoXaxis,
                                    formatter: function (value) {
                                        if (props.categories.length > 30) {
                                            let indexAtual

                                            props.categories?.forEach( (linhaCategories, index) => {
                                                if (linhaCategories === value) {
                                                    indexAtual = index
                                                }
                                            })
                                            if (indexAtual % 2 !== 0 && !props.annotations) {
                                                value = ' '
                                            }
                                        }
                                        return value
                                    }
                                },
                                //https://github.com/apexcharts/react-apexcharts/issues/315
                                crosshairs: {
                                    show: false,
                                    width: 1,
                                },
                            },
                            yaxis: {
                                show: (props.report || props.modoApresentacao) && props.stacked,
                                title: {
                                    text: '',
                                },
                                tickAmount: props.yaxisTickAmount ? props.yaxisTickAmount : undefined,
                                min: props.yaxisMin ? props.yaxisMin : undefined,
                                max: props.yaxisMax ? props.yaxisMax : undefined,
                                labels: {
                                    style:
                                        props.report
                                            ?
                                                STYLE(false, false).styleChartPadraoYaxisReport
                                            :
                                            STYLE(false, false).styleChartPadraoYaxis,
                                    formatter: function (value, opts) {

                                        let totalMedia = 0

                                        let valorSerie2 = null

                                        if (props.participacao && value && opts && opts.series) {

                                            if (props.dataPointIndexZoom >= 0) {

                                                props.series[0].data?.forEach( (linhaSeries, index) => {

                                                    if (props.series[0].media) {
                                                        
                                                        totalMedia += props.series[0].media[index]

                                                    } else {

                                                        totalMedia += linhaSeries
                                                    }
                                                })

                                            } else {

                                                props.series?.forEach( (linhaSeries, index) => {

                                                    if (
                                                        opts &&
                                                        opts.seriesIndex >= 0 &&
                                                        props.series &&
                                                        props.series[index].media
                                                    ) {
                                                        
                                                        totalMedia += 
                                                            props.series[index].media[opts.dataPointIndex]
                                                                ?
                                                                    props.series[index].media[opts.dataPointIndex]
                                                                :
                                                                    0

                                                    } else {

                                                        totalMedia += 
                                                            linhaSeries.data[opts.dataPointIndex]
                                                                ?
                                                                    linhaSeries.data[opts.dataPointIndex]
                                                                :
                                                                    0
                                                    }
                                                })
                                            }
                                        } 

                                        if (value && opts && opts.series) {

                                            valorSerie2 = props.series2 ? props.series2[opts.dataPointIndex] : null

                                        } else {

                                            valorSerie2 = null
                                        }

                                        let valueMedia

                                        if (
                                                opts &&
                                                opts.seriesIndex >= 0 &&
                                                props.series &&
                                                props.series[opts.seriesIndex] &&
                                                props.series[opts.seriesIndex].media
                                        ) {
                                            
                                            valueMedia = props.series[opts.seriesIndex].media[opts.dataPointIndex]

                                        } else {

                                            valueMedia = value
                                        }
                                    
                                        return value
                                            ?
                                                props.valorNumero === "N"
                                                    ? 
                                                        formataNumero(value)
                                                    :
                                                        (valorSerie2 ? formataNumero(valorSerie2) + ' - '  : '') +
                                                            formataValor(value, 2) +
                                                                (valorSerie2
                                                                    ?
                                                                        '<span style="font-weight:normal">' +
                                                                            ' (' + LABEL.media + ' = ' +
                                                                                formataValor(round(value / valorSerie2, 2), 2) + ') ' +
                                                                                    '</span>'
                                                                    : 
                                                                        ''
                                                                ) +
                                                                    (props.mediaMensal && opts && opts.series
                                                                        ? 
                                                                            '<span style="font-weight:normal">' +
                                                                                calculaValorMensalChart(value, opts,
                                                                                    props.dataSimulacaoEstudo, props.series,
                                                                                        props.dataPointIndexZoom) +
                                                                            "</span>"
                                                                        :
                                                                            ''
                                                                    ) + 
                                                                        (props.participacao && valueMedia && opts && opts.series
                                                                            ? 
                                                                                (props.mediaMensal
                                                                                    ?
                                                                                        '<span style="font-weight:bold">'
                                                                                    :
                                                                                        '<span style="font-weight:normal">'
                                                                                ) +
                                                                                    ' ' + (props.mediaMensal ? '' : '(') +
                                                                                        formataPerc(round(valueMedia / totalMedia * 100, 2)).trim() + (props.mediaMensal ? '' : ')') +
                                                                                "</span>"
                                                                            :
                                                                                ''

                                                                        )
                                            : 
                                                props.yaxisNullZero 
                                                    ? 
                                                        0
                                                    : 
                                                        null
                                    }
                                },
                            },
                            legend: {
                                show: props.notLegendShow ? false : true,
                                showForSingleSeries: props.notLegendShow ? false : true,
                                showForNullSeries: false,
                                showForZeroSeries: false,
                                position: 'bottom',
                                horizontalAlign: props.legendHorizontalAlign ? props.legendHorizontalAlign : 'center',
                                fontSize: props.report ? '10px' : '12px',
                                inverseOrder: props.notInverseOrder ? false : true,
                                floating: false,
                                offsetY: 7,
                                offsetX: 0,
                            },
                            tooltip: {
                                //theme: 'dark',
                                enabled: props.toolTipX || props.toolTipXTotal,
                                shared: props.toolTipX || props.toolTipXTotal,
                                followCursor: true,
                                inverseOrder: props.tooltipRegularOrder ? false : true,
                                x: {
                                    show: props.toolTipX || props.toolTipXTotal,
                                    formatter: function (coluna, opts) {
                                        let total = 0
                                        let totalMedia = 0

                                        props.series?.forEach( (linhaSeries, index) => {

                                            if (!linhaSeries.type || linhaSeries.type === 'area' || linhaSeries.type === 'bar') {

                                                if (
                                                        opts &&
                                                        (opts.seriesIndex === 0 || opts.seriesIndex) &&
                                                        props.series &&
                                                        props.series[index].media
                                                ) {
                                                    
                                                    totalMedia = totalMedia + props.series[index].media[opts.dataPointIndex]

                                                } else {

                                                    totalMedia = totalMedia + nvl(linhaSeries.data[opts.dataPointIndex], 0)
                                                }

                                                total = total + nvl(linhaSeries.data[opts.dataPointIndex], 0)
                                            }
                                        })

                                        return '&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp' +
                                            (!props.toolTipXTotal
                                                ?
                                                    /*props.dataLabelsEnabled && opts && (opts.dataPointIndex || opts.dataPointIndex === 0)
                                                        ?*/
                                                            props.categories[opts.dataPointIndex] +
                                                                (props.categories2 ? ' (' + props.categories2[opts.dataPointIndex] + ')' : '')
                                                        /*:
                                                            coluna*/
                                                : 
                                                    (props.toolTipX ? props.categories[opts.dataPointIndex]/*coluna*/ +
                                                        (props.categories2 ? ' (' + props.categories2[opts.dataPointIndex] + ')' : '') + ": " : '') +
                                                            (props.valorNumero === "N"
                                                                ?
                                                                    "<b>" + formataNumero(total) + "</b>"
                                                                :
                                                                    "<b>" + formataValor(total, 2) + "</b>" +
                                                                        (props.mediaMensal
                                                                            ? 
                                                                                calculaValorMensalChart(totalMedia, opts,
                                                                                    props.dataSimulacaoEstudo, null, null)
                                                                            :
                                                                                ''
                                                                        )
                                                            )
                                            )
                                    }
                                },
                                fixed: {
                                    enabled: props.legendFixedEnabled,
                                    position: 'topLeft',
                                    offsetX: 0,
                                    offsetY: 0,
                                },
                            },
                            ...props.labels
                        }}
                    />
                    
                    {zoom && (
                        <GridContainer>
                            <GridItem12>
                                <CustomizedDialogsPopup
                                    maxWidth='lg'
                                    popupTitle={props.titleText ? props.titleText : props.titleTextPopup}
                                    aberto={true}
                                    close={setZoom}
                                    popupComponent={
                                        <GridContainer>
                                            <GridItem6>
                                                <TabelaZoom
                                                    title={props.titleZoomTabela}
                                                    series={zoom.seriesZoom}
                                                    labels={zoom.categoriesZoom}
                                                    labelSeriesZoom={zoom.labelSeriesZoom}
                                                    totalSeries={zoom.totalSeriesZoom}
                                                />
                                            </GridItem6>

                                            <GridItem6>
                                                <ChartPadraoPie
                                                    series={zoom.seriesZoom}
                                                    labels={zoom.categoriesZoom}
                                                    paletaCores={zoom.paletaCoresZoom}
                                                    fillType='gradient'
                                                    ////fillShadeIntensity={0.3}
                                                    //labelsSomentePerc={true}
                                                    totalSeries={zoom.totalSeriesZoom}
                                                />
                                            </GridItem6>
                                        </GridContainer>
                                    }
                                />
                            </GridItem12>
                        </GridContainer>
                    )}
                </div>
            </GridItem12>
        </GridContainer>
    )
}

const TabelaZoom = ( { title, series, labels, labelSeriesZoom, totalSeries } ) => {

    const report = false

    const seriesAux = [...series]
    seriesAux.push(totalSeries)

    const labelsAux = [...labels]
    labelsAux.push(LABEL.total)


    let headList = [
        {
            colSpan: 6,
            headTitle: formataTableCellHeadExibeDadosTitulo(title, report),
        },
        {
            colSpan: 4,
            headTitle: formataTableCellHeadExibeDadosValor(labelSeriesZoom, report),
        },
        {
            colSpan: 4,
            headTitle: formataTableCellHeadExibeDadosValor(LABEL.perc, report),
        },
    ]

    return (
        <TableExibeDados
            report={report}
            noMinW={true}
        >
            <TableHeadExibeDados
                //popup={true}
            >
                <TableRowHeadExibeDados
                    dados={headList}
                />
            </TableHeadExibeDados>

            <TableBodyExibeDados>
                {seriesAux?.map((item, ind) => {

                    const total = ind === seriesAux.length - 1 ? true : false

                    return (
                        <TableRowBodyExibeDados
                            key={ind}
                            report={report}
                        >
                            <TableCellBodyExibeDados
                                colSpan={headList[0].colSpan}
                                primeiraColuna={true}
                            >
                                {total
                                    ?
                                        formataTableCellBodyExibeDadosTotalTitulo(labelsAux[ind], report)
                                    :
                                        formataTableCellBodyExibeDadosTitulo(labelsAux[ind], report)
                                }
                            </TableCellBodyExibeDados>

                            <TableCellBodyExibeDados
                                colSpan={headList[1].colSpan}
                            >
                                {total
                                    ?
                                        formataTableCellBodyExibeDadosTotalValor(item, report)
                                    :
                                        formataTableCellBodyExibeDadosValor(item, report)
                                }
                            </TableCellBodyExibeDados>

                            
                            <TableCellBodyExibeDados
                                colSpan={headList[2].colSpan}
                            >
                                {total
                                    ?
                                        ''
                                    :
                                        formataTableCellBodyExibeDadosPerc(item / totalSeries * 100, report)
                                }
                            </TableCellBodyExibeDados>
                        </TableRowBodyExibeDados>
                    )
                })}
            </TableBodyExibeDados>
        </TableExibeDados>  
    )
}

export const ChartPadraoPie = props => {

    //const colors = []

    ////props.series?.forEach( () => {
    ////    colors.push(props.dataLabelsColor ? props.dataLabelsColor : '#FFFFFF')
    ////})



    return (
        <Chart
            type='donut'
            series={props.series}
            width={props.width ? props.width : 520}
            height={props.height ? props.height : 520}
            options={{
                chart: {
                    type: 'donut',
                    fontFamily: AuthService.obterFontFamily(false), // mudança da fonte
                    animations: {
                        enabled: false,
                    },
                    events: {
                        dataPointSelection: function (e, chart, opts) {

                            if (props.eventsDataPointSelection) {

                                props.eventsDataPointSelection(
                                    {
                                        seriesIndex: opts.seriesIndex,
                                        dataPointIndex: opts.dataPointIndex,
                                        ind: props.eventsDataPointSelectionInd,
                                    }
                                )
                            }
                        }
                    },
                },
                plotOptions: {
                    pie: {
                      startAngle: -90,
                      endAngle: props.endAngle ? props.endAngle : 270,
                    },
                  },
                labels: props.labels,
                colors: props.paletaCores,
                dataLabels: {
                    enabled: false, ////true,
                    ////formatter: function (value, opts, x) {

                    ////    return props.labelsSomentePerc ? formataPerc(value, 0) : [props.labels[opts.seriesIndex], formataPerc(value, 0)]
                    ////},
                    ////style: {
                    ////    fontSize: '13px',
                    ////    colors: colors,
                    ////},
                },
                fill:
                    props.fillType === 'gradient'
                        ?
                            {
                                type: 'gradient',
                                ////gradient: {
                                ////    shade: 'light',
                                ////    type: "diagonal2",
                                ////    shadeIntensity: props.fillShadeIntensity ? props.fillShadeIntensity : 0.4,
                                ////    //gradientToColors: undefined,
                                ////    inverseColors: false,
                                ////    opacityFrom: 1,
                                ////    opacityTo: 1,
                                ////    //stops: [0, 50, 100],
                                ////    // colorStops: []
                                ////},
                                //pattern: {
                                //  style: 'verticalLines',
                                //  width: 6,
                                //  height: 6,
                                //  strokeWidth: 2,
                                //},
                            }
                        :
                            props.fillType === 'unfilled'
                                ?
                                    {
                                        type: 'solid',
                                        opacity: 0,
                                    }
                                :
                                    {
                                        type: 'solid',
                                        opacity: props.fillOpacity ? props.fillOpacity : 1,
                                    },
                stroke: {
                    width: 4
                },
                legend: {
                    show: props.notLegendShow ? false : true,
                    position: 'right', ////'bottom',
                    horizontalAlign: 'left',
                    formatter: function(val, opts) {
                        return val + ': <span style="font-weight:bold">' +
                            formataPerc(opts.w.globals.seriesPercent[opts.seriesIndex], 2) + '</span>'
                    }
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: function(value, opts) {
                            return (props.series2 ? formataNumero(props.series2[opts.seriesIndex]) + ' - '  : '') +
                                (
                                    props.seriePerc
                                        ?
                                            formataPerc(props.series[opts.seriesIndex], 2)
                                        :
                                            (props.valorNumero === 'N'
                                                ?
                                                    formataNumero(props.series[opts.seriesIndex])
                                                :
                                                    formataValor(props.series[opts.seriesIndex], 2)
                                            ) +
                                                (props.series2
                                                    ?
                                                        '<span style="font-weight:normal">' +
                                                            ' (' + LABEL.media + ' = ' + formataValor(
                                                                round(props.series[opts.seriesIndex] / props.series2[opts.seriesIndex], 2), 2) + ') ' +
                                                                    '</span>'
                                                    :
                                                        ''
                                                ) +
                                                    (props.totalSeries
                                                        ?
                                                            ' (' + formataPerc(props.series[opts.seriesIndex] / props.totalSeries * 100, 2) + ')'
                                                        :
                                                            ''
                                                    )
                                )
                        }
                    },
                },
            }}
        />
    )
}